import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { generateId } from "../id";

export const toggleRouteFavorite = mutator({
  schema: z.object({
    workflowId: z.string(),
    stepDir: z.string(),
  }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:read",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { workflow, stepDir } }) => {
    const { userId } = ctx;
    const existing = await tx.run(
      zql.routeFavorites
        .where("userId", userId)
        .where("workflowId", workflow.id)
        .where("stepDir", stepDir)
        .one()
    );

    if (existing) {
      await tx.mutate.routeFavorites.delete({ id: existing.id });
    } else {
      await tx.mutate.routeFavorites.insert({
        id: generateId(),
        userId,
        workflowId: workflow.id,
        stepDir,
        createdAt: Date.now(),
        tenantId: ctx.tenantId,
      });
    }
  },
});
